const siteData = {
  top_bar: {
    phone_number: "+91 8274949211",
    email_address: "asrm.kol@gmail.com",
  },
  navigation_bar: {
    Home: { label: "Home", link: "/" },
    Team: { label: "Team", link: "/team" },
    Services: {
      label: "Services",
      link: "/services",
      dropdown_items: [
        { label: "All Services", link: "/services" },
        { label: "Corporate Services", link: "/services/corporate-services" },
        { label: "Audit", link: "/services/audit" },
        { label: "Corporate Finance", link: "/services/corporate-finance" },
        { label: "Services for Non-Residents", link: "/services/non-residents" },
        { label: "Accounting Services", link: "/services/accounting" },
        { label: "Payroll", link: "/services/payroll" },
        { label: "Benefits of Outsourcing", link: "/services/outsourcing" },
        { label: "Income Tax", link: "/services/income-tax" },
        { label: "GST", link: "/services/gst" },
        { label: "Corporate Governance", link: "/services/corporate-governance" },
        { label: "TDS", link: "/services/tds" },
      ],
    },
    "Knowledge Bank": {
      label: "Knowledge Bank",
      link: "#",
      dropdown_items: [
        { label: "All Resources", link: "/knowledge" },
        { label: "Utilities", link: "/knowledge/utilities" },
        { label: "Acts", link: "/knowledge/acts" },
        { label: "Rules", link: "/knowledge/rules" },
        { label: "Important Links", link: "/knowledge/links" }
      ],
    },
    Query: { label: "Query", link: "https://asrm.co.in/NewThemeQuerysheet.aspx", isExternal: true },
    Careers: { label: "Careers", link: "https://asrm.co.in/resource/Career.aspx", isExternal: true },
    "Contact Us": { label: "Contact Us", link: "/contact" },
  },
  homepage_sections: {
    about_us: {
      heading: "About Us",
      paragraphs: [
        "ASRM & Co is professionally managed CA Firm having a combined experience of 30 years. The firm's constant endeavour is to craft a premier focused professional practice providing high quality services and integrating value added knowledge, for its people, clients and society as a whole. We are Young and Dynamic Chartered Accountants, offering variety of services in the field of Accounting Services, Financial and Consultancy Services, Auditing Services (Including Internal & Statutory Audit), Direct Tax Services, Indirect Tax Services. We are also specialised in providing services for Company Law Matters (including Company Incorporation Matter), Loan Financing, Project Financing, Business Consultancy Services etc.",
        "We are engaged in audit and accounting work of a variety of industries such as Sponge Iron Industries, Aluminium Industries, Carton Industries, Rice Mill, Chemical Manufacturing, Startups and many other industries. We are also engaged in providing services in different type of Service Industries such as Transporting Industries, Diagnostic and Hospital Industries, BPO Industries, Stock Broking firms. Partners are also having experience for doing inspection of Commodity Exchanges like NCDEX, MCX and other stock & commodity brokers.",
      ],
    },
    services_section: [
      {
        title: "Audit Services",
        description: "Comprehensive review to ensure that the accounts are prepared in accordance with Generally Accepted Accounting Policies and applicable Accounting Standards/IFRS. Checking the genuineness of the expenses booked in accounts.",
        read_more_link: "/services/audit",
        icon: "FaSearchDollar",
        image: "/images/services/audit.jpg"
      },
      {
        title: "Corporate Services",
        description: "Planning for Mergers, Acquisitions, De-mergers, and Corporate re-organizations. Filing of annual returns and various forms, documents. Consultancy on Company Law matters.",
        read_more_link: "/services/corporate-services",
        icon: "FaBuilding",
        image: "/images/services/corporate.jpg"
      },
      {
        title: "Accounting Services",
        description: "Accounting System Design & Implementation. Financial Accounting. Budgeting — comprehensive bookkeeping and financial record management for your business.",
        read_more_link: "/services/accounting",
        icon: "FaCalculator",
        image: "/images/services/accounting.jpg"
      },
      {
        title: "GST Services",
        description: "Filing of GST Returns (Regular Dealer, Composition Dealer, ISD, Non-Resident, E-Commerce, etc). GST Consultancy/Advisory on various issues of GST.",
        read_more_link: "/services/gst",
        icon: "FaFileInvoiceDollar",
        image: "/images/services/gst.jpg"
      },
    ],
    our_team: {
      heading: "Our Team",
      description: "Our dedicated team comprises of competent people with extensive knowledge and experience. Our professionalism and expertise helps us to service our clients to their satisfaction.",
      firm_registration: "Firm Registration of Number 328024E",
      date_of_incorporation: "Date of Incorporation 01/03/2013",
      link: "/team",
      members: [
        {
          name: "Rohit Kumarr Mundhra",
          designation: "Partner",
          initials: "RKM",
          photo: "/images/team/member1.jpg",
          description: "Rohit Kumarr Mundhra is Fellow Member of Institute of Chartered Accountant of India (since November 2008) with Graduate Honors in field of Commerce and he is also a Company Secretary and is certified Forensic Auditor and Fraud Detector together with Diploma in Information & System Audit. He is actively engaged in professional services in the field of Statutory and Tax Audit, Direct & Indirect Taxation, Company Law Matters, Business Consultancy Services etc."
        },
        {
          name: "Avik Sonthalia",
          designation: "Partner",
          initials: "AS",
          photo: "/images/team/member2.jpg",
          description: "Avik Sonthalia is a Fellow Member of Institute of Chartered Accountant of India (since May 2011) with Graduate Honors in field of Commerce, he also holds Diploma in Information & System Audit. His areas of experience include Project finance, Banking, Accounting, Auditing, Direct Taxation & Indirect Taxation."
        },
        {
          name: "Abhishek Pransukhka",
          designation: "Partner",
          initials: "AP",
          photo: "/images/team/member3.jpg",
          description: "Abhishek Pransukhka is a Fellow Member of Institute of Chartered Accountant of India (since May 2012) with Graduate Honors in field of Commerce. His areas of experience include Accounting, Auditing, Direct Taxation, Company Law Matters, Business Consultancy Services etc."
        },
      ],
    },
    contact_us: {
      heading: "Contact Us",
      address: "232 M G Road, Lamba Line, Shri Vijaya Puram (Port Blair)- 744103, Andaman & Nicobar Island",
      phone: "+91 - 9831050547",
      email: "asrm.kol@gmail.com",
      link: "/contact",
    },
  },
  footer: {
    useful_links: [
      { label: "Income Tax Dept.", href: "http://incometaxindia.gov.in/Pages/default.aspx" },
      { label: "Central Board of Excise & Customs", href: "http://cbec.gov.in/" },
      { label: "E-Tax Information Network", href: "https://www.tin-nsdl.com/" },
      { label: "Ministry of Corporate Affairs", href: "http://mca.gov.in/" },
      { label: "Employees Provident Fund", href: "http://epfindia.com/site_en/" },
    ],
    social_media_links: [
      { platform: "Facebook", href: "https://www.facebook.com/ASRM-CO-486599011395267/" },
      { platform: "LinkedIn", href: "https://www.linkedin.com/company/asrm-co/" },
    ],
    contact_email: "asrm.kol@gmail.com",
    contact_phone: "+91 8274949211",
    copyright_text: "All © Rights Reserved to www.asrm.co.in",
    powered_by_text: "Datum Radix",
  },
};

export default siteData;
